import { useDealTypeCategoryQuery } from "@api/dealTypeCategory/dealTypeCategory";
import { useSavedAsDraftContentsWithShortCut } from "@EditArticleContainer/shared/hooks/useSavedAsDraftContentsWithShortCut";
import { useClassificationManual } from "@hooks/useArticleInfo";

import * as S from "./ArticleDetailBody.style";
import { PARAGRAPH_ACCORDING_TO_CLASSIFICATION } from "./constants/common.constants";
import {
  PARAGRAPH_DEALS_LA,
  PARAGRAPH_DEALS_MA,
} from "./constants/paragraph.constants";

const DealsCategoryBody = () => {
  const { data: dealTypeCategory } = useDealTypeCategoryQuery();

  const paragraphList =
    dealTypeCategory === "LA"
      ? PARAGRAPH_DEALS_LA
      : dealTypeCategory === "MA"
      ? PARAGRAPH_DEALS_MA
      : PARAGRAPH_DEALS_LA;

  return (
    <>
      {paragraphList.map(({ component: Component, id }) => (
        <Component key={id} />
      ))}
    </>
  );
};

const ArticleDetailBody = () => {
  useSavedAsDraftContentsWithShortCut();
  const classificationManual = useClassificationManual();

  if (classificationManual === "C006") {
    return (
      <S.ArticleDetailBodyWrapper>
        <DealsCategoryBody />
      </S.ArticleDetailBodyWrapper>
    );
  }

  const paragraphList =
    PARAGRAPH_ACCORDING_TO_CLASSIFICATION[classificationManual];

  if (!paragraphList) {
    throw new Error(
      `There is no paragraph list for classification ${classificationManual}`,
    );
  }

  return (
    <S.ArticleDetailBodyWrapper>
      {paragraphList.map(({ component: Component, id }) => (
        <Component key={id} />
      ))}
    </S.ArticleDetailBodyWrapper>
  );
};

export default ArticleDetailBody;
